export const COMPONENT_KEY = {
  combinedResults: 'combinedResults',
  everywhereDestination: 'everywhereDestination',
  countryDestination: 'countryDestination',
  countryOrigin: 'countryOrigin',
} as const;
